import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_GCP_COMPUTE_INSTANCES,
  GET_GCP_COMPUTE_INSTANCES_SUCCESS,
  GET_GCP_COMPUTE_INSTANCES_ERROR,
} from "./constant";

import { getGCPComputeInstancesApi } from "./api";

function* getGCPComputeInstancesList(params) {
  try {
    const data = yield call(getGCPComputeInstancesApi, params);
    yield put({ type: GET_GCP_COMPUTE_INSTANCES_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_GCP_COMPUTE_INSTANCES_ERROR, error });
  }
}

export function* manageGCPComputeInstancesSaga() {
  yield takeLatest(GET_GCP_COMPUTE_INSTANCES, getGCPComputeInstancesList);
}
